import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";

/** Refresh icon + label (default "Try again"), the content of every retry button. */
const RetryLabel = ({ label, small = false }) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <>
      <SvgIcon
        src="/img/new-icons/vuesax-linear-refresh-2.svg"
        useCurrentColor
        classNames={`${small ? "w-3 h-3 mr-1.5" : "w-4 h-4 mr-2"} align-middle`}
      />
      {label ?? t("doorAccess.states.retry")}
    </>
  );
};

export default RetryLabel;
